<template>
  <div class="calendar">
    <iframe
      id="calendarIFrame"
      title="GolStats"
      width="100%"
      height="1000"
      scrolling="no"
      marginwidth="0"
      marginheight="0"
      frameborder="0"
      :src="calendarUrl"
    >
    </iframe>
  </div>
</template>

<script>
import b2cToken from '@/data/b2c-token';
import { mapGetters } from 'vuex';
const iframe = document.querySelector('#calendarIFrame');
window.addEventListener(
  'message',
  function (event) {
    if (event.data.message === 'heightChanged' && iframe) {
      iframe.style.height = `${event.data.newHeight}px`;
    }
  },
  false,
);
export default {
  name: 'Calendar',
  computed: {
    ...mapGetters('loginGeneral', ['isNextGamesAllowed']),
    calendarUrl() {
      return `https://bets.golstats.com/calendar-gs-2?token=${b2cToken.tokenP}`;
    },
  },
  beforeMount() {
    if (!this.isNextGamesAllowed) {
      this.$router.push({ name: 'gs' });
    }
  },
};
</script>

<style scoped lang="scss">
.calendar {
  padding-top: 2rem;

  & > iframe#calendarIFrame {
    height: 1000px;
  }
}
</style>
